import { Button, Icon } from 'rbx';
import * as React from 'react';
import { useMutation } from '@apollo/client';

import { IBasketFileModel } from '../../../models/IBasketModel';
import { BASKET_FILE_DELETE_MUTATION, BASKET_FILES } from './../../../api/GraphQLQueries/Basket';
import { notification } from './../../../utils/notification';

interface IProps {
    file: IBasketFileModel;
    basketId: string;
}

const BasketFileDeleteMutation: React.FC<IProps> = ({ file, basketId }) => {

    const [deleteFile] = useMutation(BASKET_FILE_DELETE_MUTATION, {
        onCompleted: () => {
            notification.success('Successfully deleted file');
        },
        onError: () => {
            notification.error('File delete error');
        },
        refetchQueries: basketId ? [{ query: BASKET_FILES, variables: { basketId } }] : [],
    });

    const handleDelete = () => {
        if (window.confirm(`Are you sure? This action can not be undone.`)) {
            deleteFile({
                variables: { basketId, filename: file.filename, isQuote: file.isQuote },
            });
        }
    };

    return (
        <Button size="small" onClick={handleDelete}>
            <Icon>
                <i className="fa fa-trash-alt" />
            </Icon>
        </Button>
    );
};

export default BasketFileDeleteMutation;
